export const greaterThanFunction = (rows, id, filterValue) =>
    rows.filter((row) => {
        return row.original[id] >= filterValue;
    }
    );

export const typeFilterFunction = (rows, id, filterValue) =>
    rows.filter((row) => {
        if (filterValue == 'all')
            return true;
        else
            return row.original[id] == filterValue;
    }
    );

export const includeFilterFunction = (rows, id, filterValue) =>
    rows.filter((row) => {
        if (filterValue)
            return row.original[id].indexOf(filterValue) >= 0;
        else
            return true;
    }
    );